import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var config = {
  apiKey: "AIzaSyAhN3kqRiKNShDwF13sxkmszR7ko1oL-jQ",
  authDomain: "repfinder-58015.firebaseapp.com",
  databaseURL: "https://repfinder-58015.firebaseio.com",
  projectId: "repfinder-58015",
  storageBucket: "repfinder-58015.appspot.com",
  messagingSenderId: "456711745021"
}

var fb = firebase.initializeApp(config)

export { fb }


// WEBPACK FOOTER //
// ./src/utils/api.js